import { render, staticRenderFns } from "./SearchLoans.vue?vue&type=template&id=3f4c1765&scoped=true"
import script from "./SearchLoans.vue?vue&type=script&lang=js"
export * from "./SearchLoans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4c1765",
  null
  
)

export default component.exports